import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import BrutalistButton2 from '../shared/BrutalistButton2';
import './ListarSegmentacoes.css';
import { listarSegmentacoes, deletarSegmentacao } from '../../../../services/api';

const ListarSegmentacoes = ({ onEditSegmentacao, onCriarSegmentacao }) => {
  //const { setTab } = useContext(TabContext);
  const [segmentacoes, setSegmentacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    async function fetchSegmentacoes() {
      setLoading(true);
      try {
        const data = await listarSegmentacoes();
        // Mapeia os dados para o formato desejado
        const mapped = data.map(seg => {
          const fontes = [
            ...new Set(
              (seg.criterios?.condicoes || []).map(cond => cond.app_name)
            )
          ];
          // Monta um texto descritivo (exemplo simples)
          const criteriosTexto = (seg.criterios?.condicoes || [])
            .map(cond =>
              `${cond.campo} ${cond.operador} ${cond.valor} (${cond.app_name})`
            )
            .join(
              seg.criterios?.operador_logico
                ? ` ${seg.criterios.operador_logico} `
                : ' AND '
            );
          // Preserva o objeto original para edição (inclui criterios, condicoes, etc.)
          return {
            ...seg,
            fontes,
            criteriosTexto
          };
        });
        setSegmentacoes(mapped);
      } catch (err) {
        setSegmentacoes([]);
      }
      setLoading(false);
    }
    fetchSegmentacoes();
  }, []);

  const handleExcluir = async (id) => {
    try {
      await deletarSegmentacao(id);
      setSnackbar({ open: true, message: 'Segmentação excluída com sucesso!', severity: 'success' });
      setSegmentacoes(segmentosAtuais =>
        segmentosAtuais.filter(seg => seg.id !== id)
      );
    } catch (error) {
      console.error('Erro ao excluir segmentação:', error);
      setSnackbar({ open: true, message: 'Erro ao excluir segmentação.', severity: 'error' });
    }
  };

  return (
    <div className="segmentacoes-wrapper">
      <div className="segmentacoes-header" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem'
      }}>
        <h1 className="segmentacoes-title" style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          borderBottom: '4px solid #000',
          display: 'inline-block',
          paddingBottom: '4px',
          transform: 'rotate(-1deg)',
          margin: 0
        }}>
          SEGMENTAÇÕES
        </h1>
        <BrutalistButton2 className="orange" onClick={onCriarSegmentacao}>
          CRIAR SEGMENTAÇÃO
        </BrutalistButton2>
      </div>

      <div className="segmentacoes-lista">
        {loading && <div>Carregando...</div>}
        {!loading && segmentacoes.length === 0 && <div>Nenhuma segmentação encontrada.</div>}
        {segmentacoes.map((seg) => (
          <div key={seg.id} className="segment-card">
            <div className="segment-info">
              <div className="segment-nome">{seg.nome}</div>
              <div className="segment-tags">
                {seg.fontes.map((fonte, idx) => (
                  <span key={idx} className="segment-tag">{fonte}</span>
                ))}
              </div>
            </div>
            <div className="segment-acoes">
              <button
                type="button"
                className="segment-edit"
                onClick={() => onEditSegmentacao(seg)}
                aria-label="Editar segmentação"
              >
                ✏️
              </button>
              <button
                type="button"
                className="segment-delete"
                onClick={() => handleExcluir(seg.id)}
                aria-label="Excluir segmentação"
              >
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default ListarSegmentacoes;
